// extracted by mini-css-extract-plugin
export default {"container":"NouKz6gd"};